<template>
  <div class="text-center md-layout md-alignment-center-center">
    <md-checkbox v-if="hasPermission && !value" @change="updateValue" v-model="updatedValue"></md-checkbox>

    <md-icon v-else :class="value ? 'text-success' : 'text-danger'">
      {{ value ? "check_circle" : "cancel" }}
      <md-tooltip>Aprobado {{ validationDate | fromNowDate }}</md-tooltip>
    </md-icon>
  </div>
</template>

<script>
import usesAccountInfoMixin from "@/mixins/usesAccountInfo";

const supplyDescription = function (supply) {
  return `
  <strong> Código </strong> ${supply.code}\
  <br/>
  <strong> Insumo: </strong> ${supply.name}\
`;
};

const validationRoles = {
  purchase: {
    roles: ["COMPRAS", "ADM"],
    label: "Compras",
  },
  are: {
    roles: ["ARE", "ADM"],
    label: "Rentabilidad",
  },
};

export default {
  name: "SupplyValidator",

  props: {
    role: {
      type: String,
      required: true,
      validator: (value) => !!validationRoles[value],
    },

    value: {
      type: Boolean,
      required: true,
    },

    supply: {
      type: Object,
      required: true,
    },
  },

  mixins: [usesAccountInfoMixin],

  data() {
    return {
      updatedValue: this.value,
    };
  },

  computed: {
    hasPermission() {
      const { userRoleIs, role } = this;
      const roles = validationRoles[role].roles;
      return !!userRoleIs(...roles);
    },
    validationDate() {
      const { value, role } = this;
      if (!value) {
        return;
      }
      return this.supply[`${role}ValidationDate`];
    },
  },

  watch: {
    value(newValue) {
      this.updatedValue = newValue;
    },
  },

  methods: {
    updateValue() {
      const { label } = validationRoles[this.role];
      this.$fire({
        title: `¿Aprobar insumo por ${label}?`,
        html: supplyDescription(this.supply),
        footer: "Esta acción no podrá deshacerse.",
        icon: "warning",
        showCancelButton: true,
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.value) {
          this.$emit("supplyValidated");
        } else {
          this.updatedValue = false;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.md-checkbox {
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/Catalogs/Supplies/Validation/SupplyValidator.vue